import { render, staticRenderFns } from "./isRealNameNo.vue?vue&type=template&id=7881b250"
import script from "./isRealNameNo.vue?vue&type=script&lang=js"
export * from "./isRealNameNo.vue?vue&type=script&lang=js"
import style0 from "./isRealNameNo.vue?vue&type=style&index=0&id=7881b250&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7881b250')) {
      api.createRecord('7881b250', component.options)
    } else {
      api.reload('7881b250', component.options)
    }
    module.hot.accept("./isRealNameNo.vue?vue&type=template&id=7881b250", function () {
      api.rerender('7881b250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/ozonPrint/components/isRealNameNo.vue"
export default component.exports